import { Box } from "./Box";
import { ILaya } from "../../ILaya";
export class ScaleBox extends Box {
    constructor() {
        super(...arguments);
        this._oldW = 0;
        this._oldH = 0;
    }
    onResize() {
        if (this.width > 0 && this.height > 0) {
            let stage = ILaya.stage;
            let scale = Math.min(stage.width / this._oldW, stage.height / this._oldH);
            super.width = stage.width;
            super.height = stage.height;
            this.scale(scale, scale);
        }
    }
    onEnable() {
        ILaya.stage.on("resize", this, this.onResize);
        this.onResize();
    }
    onDisable() {
        ILaya.stage.off("resize", this, this.onResize);
    }
    _transChanged(kind) {
        super._transChanged(kind);
        this._oldW = this._width;
        this._oldH = this._height;
    }
}
